import React from 'react';
import ContentLoader from 'react-content-loader';

function ProfileSkeleton() {
  return (
    <ContentLoader
      className="Profile"
      height={40}
      width={40}
      speed={1}
      viewBox="0 0 40 40"
      backgroundColor="#212121b3"
      foregroundColor="#414141b3"
      style={{
        height: '40px',
        width: '40px',
        borderRadius: '100%',
        overflow: 'hidden',
      }}
    >
      <circle cx="20" cy="20" r="20" />
    </ContentLoader>
  );
}

export default ProfileSkeleton;
